<div class="container animated fadeInRight">
  <app-lfsa-card [innTemplate]="Administrador" [titulo]="'Datos Administrador'" [efecto]="true"
    [colapseName]="'administrador'" [banderaColapse]='true'></app-lfsa-card>
  <ng-template #Administrador>
    <div class="row col-12">
      <div class="col-md-6">
        <h5><b>Nombres :</b>&nbsp;{{ dataUsuario.firstName }}</h5>
      </div>
      <div class="col-md-6">
        <h5><b>Apellidos :</b>&nbsp;{{  dataUsuario.lastName }}</h5>
      </div>
      <hr>
    </div>
  </ng-template>

  <div class="row">
    <div class="col-md-12">
      <button [routerLink]="['/distribuidor/upload-csv-dis'] " class="btn btn-primary btn-block btn-lg">Carga Matriz Censo de Cliente</button>
    </div>
  </div>
  <br>
  <div class="row">
    <div class="col-md-12">
      <button [routerLink]="['/distribuidor/upload-csv-presupuesto'] " class="btn btn-primary btn-block btn-lg">Carga de Presupuesto</button>
    </div>
  </div>
  <br>
  <div class="row">
    <div class="col-md-12">
      <button [routerLink]="['/distribuidor/upload-csv-ruta'] " class="btn btn-primary btn-block btn-lg">Carga Ruta</button>
    </div>
  </div>
  <br>
  <div class="row">
    <div class="col-md-12">
      <button [routerLink]="['/distribuidor/mantenedor-distribuidor'] " class="btn btn-primary btn-block btn-lg">Mantenedor Distribuidor</button>
    </div>
  </div>
  <br>
  <!--<div class="row">
    <div class="col-md-12">
      <button [routerLink]="['/distribuidor/download-csv-file'] " class="btn btn-primary btn-block btn-lg">Download CSV</button>
    </div>
  </div>-->
</div>